import { validationTypes } from "../../components/FinalForms/libs/data/ValidationTypes";
import { FormFieldTypes } from "../../components/FinalForms/libs/data/formFieldType";
import { GridColumnType } from "../../data/gridColumnType";

const initState = {
  mainSkillName: "",
  skillCategoriesId: "",
  description: ""
};

export const MainSkillCategoryDataFields = {
  name: "Add MainSkillCategory",
  initialState: initState,
  section: [
    {
      title: "Add MainSkillCategory Section",
      row: {},
      style: {
        sectionStyle: "row",
      },
      fields: [
        {
          id: "mainSkillName",
          label: "Main Skill Name",
          Field_Name: "Main Skill Name",
          fieldType: FormFieldTypes.INPUT,
          dataField: "mainSkillName",
          fieldSetting: {
            placeholder: "Please Enter Skill Name",
            // isMultiSelect: true,
            options: [],
            maxLength: 50,
          },
          changeAction: {
            resetValue: [
              {
                dataField: "mainSkillName",
                value: null
              }
            ]
          },
          validation: [{ type: validationTypes.REQUIRE }],
          style: {
            containerCss: "col-md-6 mb-2",
          },
        },
        {
          id: "skillCategoriesId",
          label: "Skill Category",
          Field_Name: "Skill Category",
          fieldType: FormFieldTypes.SELECT,
          dataField: "skillCategoriesId",
          fieldSetting: {
            placeholder: "Please Select Skill Name",
            // isMultiSelect: true,
            options: [],
          },
          changeAction: {
            resetValue: [
              {
                dataField: "skillCategoriesId",
                value: null
              }
            ]
          },
          validation: [{ type: validationTypes.REQUIRE }],
          style: {
            containerCss: "col-md-6 mb-2",
          },
        },
        {
          id: "description",
          label: "Description",
          Field_Name: "Description",
          fieldType: FormFieldTypes.TEXTAREA,
          dataField: "description",
          fieldSetting: {
            placeholder: "Enter Description",
            allowSpace: true,
          },
          validation: [{ type: validationTypes.REQUIRE }],
          style: {
            containerCss: "col-md-12 mb-2",
          },
        },
      ],
    }
  ],
  formSetting: {
    isViewOnly: false,
}
};
//** Table columns configuration */
export const MainCategoryListGridConfig = {
  columns: [
    {
      name: "Main Skill Name",
      fieldName: "mainSkillName",
      allowShort: false,
    },
    {
      name: "Skill Category Name",
      fieldName: "skillCategoriesName",
      allowShort: false,
    },   
    {
      name: "Description",
      fieldName: "description",
      allowShort: false,
    },
    {
      name: "Created Date",
      fieldName: "createdAt",
      allowShort: false,
      colType: GridColumnType.DATE,
      colSettings: {
        isUTC: true,
        format: "DD/MM/YYYY hh:mm A ",
      },
    },
    {
      name : "CreatedBy",
      fieldName : "createdByFullName",
      allowShort: false,
    },
    {
      name: "Updated Date",
      fieldName: "updatedAt",
      allowShort: false,
      //colType: GridColumnType.DATE,
      // colSettings: {
      //   isUTC: true,
      //   format: "DD/MM/YYYY hh:mm A ",
      // },
    },
    {
      name : "Updated By",
      fieldName : "updatedByFullName",
      allowShort: false,
    },
    {
      name: "Action",
      colType: GridColumnType.ACTION,
      colStyle: {
        width: "20%",
      },
      defaultAction: {
        allowEdit: true,
        allowDelete: true,
    },
      customAction: [
        {
          name: "ADDSUBSKILLS",
          isIcon:true,
          iconName: "icon-park-outline:add-web",
          title: "Add SubSkills",
          isActive: true,
        },
      ],
    },

  ],
}
